import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'querystring';
import { setLastPaymentAttempt } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Payment/PaymentTabUtils';
import PaymentTab from './PaymentTab';
import { TripType } from '../../BookingWizardTypes';

export interface PaymentTabWrapProps {
	paymentCompletedUrl: string;
	timeoutExpiryUrl: string;
	nameToPrefill: string;
	onCompletePayment: () => void;
	onPageLoaded: () => void;
	returnTrip: boolean;
	userId?: string;
	isAlteration: boolean;
	tripType?: TripType;
	bookingToEditId?: string;
	eventBooking: boolean;
}

export function PaymentTabWrap({
	paymentCompletedUrl,
	timeoutExpiryUrl,
	nameToPrefill,
	onCompletePayment,
	onPageLoaded,
	returnTrip,
	userId,
	isAlteration,
	tripType,
	bookingToEditId,
	eventBooking,
}: PaymentTabWrapProps) {
	const queryParams = useLocation().search.substring(1);
	const params = queryString.parse(queryParams);
	const { ErrorCode } = params;

	// We may not have a code if we are just navigating to the page normally, so we need to ensure that we are able to
	// render the payment tab without having received an error code
	let code;
	if (typeof ErrorCode === 'string' && ErrorCode !== '') {
		code = ErrorCode;

		// We need to remove the error code from the url because if a user accidentally refreshes the page, they will
		// have the error message shown again.
		//
		// The other ripple effect is that it make our redirect logic to AwaitingPaymentPage not work, because it only
		// works when 'errorCode' is null
		const [pathWithoutSearchParam] = window.location.href.split('?');
		window.history.replaceState({}, 'Payment', pathWithoutSearchParam);
	} else {
		code = null;
	}

	return (
		<PaymentTab
			paymentCompletedUrl={paymentCompletedUrl}
			timeoutExpiryUrl={timeoutExpiryUrl}
			nameToPrefill={nameToPrefill}
			errorCode={code}
			onPageLoaded={onPageLoaded}
			returnTrip={returnTrip}
			userId={userId}
			isAlteration={isAlteration}
			tripType={tripType}
			bookingToEditId={bookingToEditId}
			eventBooking={eventBooking}
		/>
	);
}
